import React, { useEffect } from 'react';

import { useExchangeRate } from '$contexts/exchange-rate';
import BaseSelect from '$partials/fields/select.jsx';
import { usePersistedCookieState } from '$utilities/data';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/ui.d.ts').CurrencySelector}
 */
const CurrencySelector = ({className}) => {

    const {
        currency,
        setCurrency
    } = useExchangeRate();

    const firstPathSegment = (typeof window !== 'undefined' ? window.location.pathname.split('/').filter(Boolean)[0] : '') || '';
    const { value: currencyCookie, setValue: setCurrencyCookie, isReady } = usePersistedCookieState('GBP', `${firstPathSegment}_currency_cookie`);


    useEffect(() => {
        if (isReady && currencyCookie) {
            setCurrency(currencyCookie);
        }
    }, [isReady, currencyCookie]);

    const currencyOptions = [
        { label: 'GBP', value: 'GBP' },
        { label: 'EUR', value: 'EUR' },
        { label: 'USD', value: 'USD' },
        { label: 'ILS', value: 'ILS' },
    ];

    return (
        <BaseSelect
            displayValue={currencyOptions.find((opt) => opt.value === currency)?.label}
            name='currency'
            onChange={(selectedCurrency) => {
                setCurrency(selectedCurrency);
                setCurrencyCookie(selectedCurrency);
            }}
            options={currencyOptions}
            triggerClassName={className}
            value={currency} />
    );
};

/* ========================================================================= */
/* Export(s) */
/* ========================================================================= */

export default CurrencySelector;
